import { connect } from "react-redux";
import Folder from "../components/Folder";
import {
  changeFolderCalculsPage,
  changeFolderCalculsSearch,
  getArchivedCalculs,
  getFolder,
  loadFolderCalculs,
  updateFolder,
  updateFolderCalculsFilters,
  updateFolderCalculsLimit,
} from "../actions";
import {
  closeCalculsFiltersSection,
  openCalculsFiltersSection,
} from "../../calcul/actions";
import { defaultCalculsFilters } from "../../calcul/constants";

export default connect(
  (state) => ({
    folderCalculs: state.folders.folderCalculs,
    isFoldersLoading: state.folders.isLoading,
    folderCalculsCurrentPage: state.folders.folderCalculsCurrentPage,
    folderCalculsLimit: state.folders.folderCalculsLimit,
    folderCalculsTotal: state.folders.folderCalculsTotal,
    localConfigurator: state.configurator.localConfigurator,
    folder: state.folders.folder,
    folderCalculsSearch: state.folders.folderCalculsSearch,
    isGeneratingReports: state.loader.isGeneratingReports,
    isDownloadingReports: state.loader.isDownloadingReports,
    isFilterSectionOpen: state.calculs.isFilterSectionOpen,
    folderCalculsFilters:
      state.folders.folderCalculsFilters || defaultCalculsFilters,
  }),
  (dispatch) => ({
    loadFolderCalculs: (folderId) => {
      dispatch(loadFolderCalculs(folderId));
    },
    changeFolderCalculsPage: (page, folderId) => {
      dispatch(changeFolderCalculsPage(page, folderId));
    },
    updateFolderCalculsLimit: (limit, folderId) => {
      dispatch(updateFolderCalculsLimit(limit, folderId));
    },
    updateFolder: (folderDatas) => {
      dispatch(updateFolder(folderDatas));
    },
    getFolder: (folderId) => {
      dispatch(getFolder(folderId));
    },
    getArchivedCalculs: () => {
      dispatch(getArchivedCalculs());
    },
    changeFolderCalculsSearch: (search, folderId) => {
      dispatch(changeFolderCalculsSearch(search, folderId));
    },
    openCalculsFiltersSection: () => {
      dispatch(openCalculsFiltersSection());
    },
    closeCalculsFiltersSection: () => {
      dispatch(closeCalculsFiltersSection());
    },
    updateFolderCalculsFilters: (filters, folderId) => {
      dispatch(updateFolderCalculsFilters(filters, folderId));
    },
  }),
)(Folder);
